import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, LockKeyhole } from "lucide-react";
import { useAuth, formatApiError } from "../auth";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(username, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err, "Unable to sign in."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="login-page" data-testid="admin-login-page">
      <section className="login-card">
        <Link className="login-back" data-testid="login-back-link" to="/"><ArrowLeft size={16}/> Back to website</Link>
        <img src="/bvc-logo.png" alt="BVC Property Services logo" data-testid="login-logo"/>
        <p className="login-kicker"><LockKeyhole size={14}/> Secure admin access</p>
        <h1>Manage the BVC landing page.</h1>
        <p>Sign in to edit content, save a draft, preview it and publish when ready.</p>
        <form onSubmit={submit} data-testid="admin-login-form">
          <label>Username<input data-testid="admin-username-input" type="text" required value={username} onChange={(event) => setUsername(event.target.value)} placeholder="Your username"/></label>
          <label>Password<input data-testid="admin-password-input" type="password" required value={password} onChange={(event) => setPassword(event.target.value)} placeholder="Your password"/></label>
          {error && <p className="login-error" data-testid="login-error-message">{error}</p>}
          <button data-testid="admin-login-button" disabled={loading} type="submit">{loading ? "Signing in…" : "Sign in"}</button>
        </form>
      </section>
    </main>
  );
}
